import React from 'react';
import { FiMapPin, FiUser } from 'react-icons/fi';
import { ReactComponent as DashboardIcon } from '../assets/icons/DashboardIcon.svg';
import { ReactComponent as MetersIcon } from '../assets/icons/metersIcon.svg';
import { ReactComponent as PendingToVerifyIcon } from '../assets/icons/Pending to Verify.svg';
import { ReactComponent as RejectedIcon } from '../assets/icons/Rejected.svg';
import { ReactComponent as AcceptedIcon } from '../assets/icons/acceptedIcon.svg';
import { ReactComponent as FieldOfficerIcon } from '../assets/icons/Field Officer.svg';
import { ReactComponent as TicketsIcon } from '../assets/icons/Tickets.svg';
import { ReactComponent as SettingsIcon } from '../assets/icons/settings.svg';

export const SIDEBAR_CONFIG = [
  { id: 'dashboard', route: '/', label: 'Dashboard', icon: <DashboardIcon /> },
  { id: 'meters-installed', route: '/meters-installed', label: 'Meters Installed', icon: <MetersIcon /> },
  { id: 'pending-to-verify', route: '/pending-to-verify', label: 'Pending to Verify', icon: <PendingToVerifyIcon /> },
  { id: 'accepted', route: '/accepted', label: 'Accepted', icon: <AcceptedIcon /> },
  { id: 'rejected', route: '/rejected', label: 'Rejected', icon: <RejectedIcon /> },
  { id: 'field-officers', route: '/field-officers', label: 'Field Officers', icon: <FieldOfficerIcon /> },
  { id: 'tickets', route: '/tickets', label: 'Tickets', icon: <TicketsIcon /> },
  { id: 'locations', route: '/locations', label: 'Locations', icon: <FiMapPin aria-hidden /> },
  { id: 'users', route: '/users', label: 'Users', icon: <FieldOfficerIcon /> },

  { id: 'profile', route: '/profile', label: 'Profile', icon: <FiUser aria-hidden /> },
  { id: 'settings', route: '/settings', label: 'Settings', icon: <SettingsIcon /> },
];

